import React from 'react';
import styled from 'styled-components';
import { Heading1 } from '../components/Typography';

const NotFoundContainer = styled.div`
  text-align: center;
  margin-top: 80px;
  margin-bottom: 200px;
`;

const Heading = styled(Heading1)`
  font-size: 90px;
`;

const NotFound = () => (
  <NotFoundContainer>
    <Heading>404</Heading>
    <p>That page can't be found.</p>
  </NotFoundContainer>
);

export default NotFound;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/notfound.tsx